import { config } from '@/config';
import { REST_OF_THE_WORLD } from '@/constants';
import { SHOP_ADD_PROVINCE_OPTIONS, SHOP_CUSTOM_SPAIN_PROVINCE_NAME } from '@/constants/custom-shop-name';
import { stringify } from '@/helpers/string';
import { locationApiCaller } from '@/redux/query';
import { IParamsApi } from '@/types/apis/params';
import { useMemo } from 'react';

// if you want to get all but
interface IProps {
  countries?: boolean;
  states?: {
    countryCode: string;
  };
  unionParams?: IParamsApi.IUnionParams;
  union?: boolean;
}

const useLocationOptions = (props: IProps) => {
  const { data: countries, isFetching: isFetchingCountries } = locationApiCaller.useGetCountriesQuery(
    {
      perPage: -1,
    },
    { skip: !props.countries },
  );

  const { data: states, isFetching: isFetchingStates } = locationApiCaller.useGetStatesQuery(
    {
      countryCode: props.states?.countryCode,
      perPage: -1,
    },
    { skip: !props.states?.countryCode },
  );

  const { data: unionRes } = locationApiCaller.useGetUnionsQuery(props?.unionParams || {}, {
    skip: !props?.union,
  });

  const unionOptions = useMemo(() => {
    if (unionRes?.data) {
      const temp = unionRes.data.result.map((item) => {
        return {
          value: item.code,
          label: item.name,
        };
      });

      temp.push({
        value: REST_OF_THE_WORLD,
        label: 'Rest of the world',
      });

      return temp;
    }
    return [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stringify(unionRes?.data)]);

  const countryOptions = useMemo(() => {
    if (countries) {
      const result = countries.data.result.map((item) => {
        return {
          value: item.isoCode,
          label: item.name,
        };
      });
      return result;
    }
    return [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stringify(countries)]);

  const stateOptions = useMemo(() => {
    if (states) {
      const result = states.data.result.map((item) => {
        if (SHOP_CUSTOM_SPAIN_PROVINCE_NAME[config.shop || '']) {
          const customProvinceName = SHOP_CUSTOM_SPAIN_PROVINCE_NAME[config.shop || ''][item.isoCode];
          if (customProvinceName) {
            return {
              value: item.isoCode,
              label: customProvinceName,
            };
          }
        }
        return {
          value: item.isoCode,
          label: item.name,
        };
      });
      const customProvinceOptions = SHOP_ADD_PROVINCE_OPTIONS[config.shop || ''];
      if (customProvinceOptions) {
        return [...result, ...customProvinceOptions];
      }
      return result;
    }
    return [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stringify(states), stringify(countries)]);

  return {
    countries,
    states,
    isFetchingCountries,
    isFetchingStates,
    countryOptions,
    stateOptions: props.states?.countryCode ? stateOptions : [],
    unionOptions,
  };
};

export default useLocationOptions;
